import * as React from "react";
import type { SVGProps } from "react";
const BulletedList01Icon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><circle cx={7} cy={12} r={3} fill="currentColor" /></svg>;
export default BulletedList01Icon;